import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {ControllerParams} from '@wix/yoshi-flow-editor'
import {Api} from '../api/api'
import {State} from '../reducers'

type Extra = {
  api: Api
  controllerParams: ControllerParams
}

export const createAsyncAction = asyncActionsFactory<State, Extra>()
